import { axiosInventoryInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import {
  IFetchOperators,
  IUser,
  IOperator,
  IDeleteOperator,
} from '@/services/operator/operator.type';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import {
  ALL_PROVIDER,
  ALL_SUB_APPLICATION,
} from '@/constant/global/global.constant';
import { isSameRequestParams } from '@/utils/requestParamsChecker';

export const fetchOperators = ({
  page = 1,
  limit = 10,
  name = '',
  providerId = '',
  orderBy,
  order,
  subapplicationId,
  includeInactive,
  inactive,
}: IFetchOperators): Promise<AxiosResponse<IFetchOperators, any>> => {
  name && (name = name?.trim());
  return axiosInventoryInstance({
    url: API_URL_CONFIG.OPERATOR.GET_OPERATORS,
    params: {
      page,
      limit,
      ...(name?.length && { name }),
      ...(providerId?.length && providerId !== '1' && { providerId }),
      ...(subapplicationId !== ALL_SUB_APPLICATION.id
        ? { subapplicationId }
        : {}),
      ...(order ? { order } : {}),
      ...(orderBy ? { orderBy } : {}),
      ...(includeInactive ? { includeInactive } : {}),
      ...(inactive ? { inactive } : {}),
    },
  });
};

export const fetchOperator = (id: string): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.get(
    `${API_URL_CONFIG.OPERATOR.GET_OPERATORS}/${id}`,
  );
};

export const createOperator = (
  payload: IOperator,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.post(
    `${API_URL_CONFIG.OPERATOR.GET_OPERATORS}`,
    payload,
  );
};

export const updateOperator = (
  id: string,
  payload: IOperator,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.OPERATOR.GET_OPERATORS}/${id}`,
    payload,
  );
};

export const deleteOperator = (
  id: IDeleteOperator,
): Promise<AxiosResponse<IDeleteOperator, any>> => {
  return axiosInventoryInstance.delete(
    `${API_URL_CONFIG.OPERATOR.GET_OPERATORS}/${id}`,
  );
};

export const activateOperator = (
  id: string,
): Promise<AxiosResponse<IUser>> => {
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.OPERATOR.GET_OPERATORS}/${id}/activate`,
    {},
  );
};

export const fetchAllOperatorsList = ({
  page = 1,
  limit = 50,
  name = '',
  providerId = '',
  orderBy,
  order,
  keywords,
}: IFetchOperators): Promise<AxiosResponse<IFetchOperators, any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.OPERATOR.GET_OPERATORS_LIST,
    params: {
      page,
      limit,
      ...(name?.length && { name }),
      ...(providerId?.length &&
        providerId !== ALL_PROVIDER.id && { providerId }),
      ...(keywords?.length && { keywords }),
      orderBy,
      order,
    },
  });
};